import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ElementRef, AfterViewInit} from '@angular/core';
import { DocumentSchema } from '../../../store/models/document.model';
import { SchemaField, FieldDataType, dataTypes, SystemFieldType } from 'src/app/modules/core/store/models/document.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'topo-table-select-columns',
    templateUrl: './select-columns.component.html',
    styleUrls: ['./select-columns.component.scss'],
    standalone: false
})
export class TableColumnSelection implements  OnInit, OnDestroy {

  @Input() visible: boolean;
  @Input() set columns(value: any[]) {
    this._columns = value;
    if (!!this._schema && this.visible) {
      this.selectedColumns = this.getSelectedColumns(value);
    }
  }
  @Input() showSystemFields: boolean;
  @Input() set schema(value: DocumentSchema) {
    this._schema = value;
    this.fieldsForTable = this.getFieldsForTable();
    if (!!this._columns && this.visible) {
      this.selectedColumns = this.getSelectedColumns(this._columns);
    }
  }
  @Output() save = new EventEmitter<string[]>();
  @Output() reset = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  _schema: DocumentSchema;
  _columns: any[];
  fieldsForTable: any[];
  searchTerm: string;
  selectedColumns: SchemaField[];
  showConfirmReset: boolean;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  private getFieldsForTable(): any[] {

    const fieldsForTable = this._schema?.fields
    .filter(f => (f.fieldType & SystemFieldType.Hidden) !== SystemFieldType.Hidden)
    .filter(f => (this.showSystemFields ? true : (f.fieldType & SystemFieldType.Editable) === SystemFieldType.Editable))
    .filter(f => (dataTypes.find(d => d.type === f.dataType)))
    .filter(f => (!!this.searchTerm ? f.displayName.toLowerCase().includes(this.searchTerm.toLowerCase()) : true))
    .map(f => {
      return {
        ...f,
        dataTypeIcon: this.translate.instant(this.getDataTypeIcon(f.dataType)),
        dataTypeDisplay: this.translate.instant(this.getDataTypeLabel(f.dataType)),
        fieldTypeDisplay: this.translate.instant(this.getFieldTypeLabel(f.fieldType)),
      };
    })
    .sort((f1, f2) => {
      if (f1.displayName < f2.displayName) {
        return -1;
      } else if (f1.displayName > f2.displayName) {
        return 1;
      } else {
        return 0;
      }
    });

    return fieldsForTable;
  }

  private getSelectedColumns(columns: any): SchemaField[] {
    let selectedColumns = [];

    if (!!columns) {
      columns.map(c => {
        if (!!c.field) {
          const field = this._schema?.fields.find(f => f.systemName === c.field);
          if (!!field) {
            selectedColumns.push(field);
          }
        }
      });
    }

    return selectedColumns;
  }

  private getDataTypeLabel(dataType: FieldDataType) {
    return dataTypes.find(f => f.type === dataType)?.label;
  }

  private getDataTypeIcon(dataType: FieldDataType) {
    return dataTypes.find(f => f.type === dataType)?.icon;
  }

  private getFieldTypeLabel(fieldType: SystemFieldType) {
    if (
      (fieldType & SystemFieldType.Editable) === SystemFieldType.Editable &&
      (fieldType & SystemFieldType.Deletable) === SystemFieldType.Deletable
    ) {
      return 'MANAGEMENT.DATASETS.FIELD-TYPE-CUSTOM';
    }

    if (
      (fieldType & SystemFieldType.System) === SystemFieldType.System &&
      (fieldType & SystemFieldType.Editable) === SystemFieldType.Editable
    ) {
      return 'MANAGEMENT.DATASETS.FIELD-TYPE-STANDARD';
    }

    if (
      (fieldType & SystemFieldType.System) === SystemFieldType.System &&
      (fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable &&
      (fieldType & SystemFieldType.Deletable) !== SystemFieldType.Deletable
    ) {
      return 'MANAGEMENT.DATASETS.FIELD-TYPE-SYSTEM';
    }
    return "--";
  }

  isSelected(field: any): boolean {
    return !!this.selectedColumns?.find(c => c.systemName === field.systemName);
  }

  toggleSelected(field: any): void {
    if (this.isSelected(field)) {
      this.removeSelectedColumn(field);
    } else {
      this.addSelectedColumn(field);
    }
  }

  addSelectedColumn(field: any): void {
    if (!this.selectedColumns?.find(c => c.systemName === field.systemName)) {
      this.selectedColumns.push(field);
    }
  }

  removeSelectedColumn(field: any): void {
    const index = this.selectedColumns?.findIndex(c => c.systemName === field.systemName);
    if (index >= 0) {
      this.selectedColumns.splice(index, 1);
    }
  }

  dragDropColumn({ previousIndex, currentIndex }): void {
    const fieldToMove = this.selectedColumns.splice(previousIndex, 1);
    this.selectedColumns.splice(currentIndex, 0, ...fieldToMove);
  }

  onClose(): void {
    this.close.emit();
  }

  saveClick(): void {
    const columnNames = [];
    this.selectedColumns.map(c => columnNames.push(c.systemName));
    this.save.emit(columnNames);
  }

  resetClick(): void {
    this.showConfirmReset = true;
  }

  confirmResetResponse(confirm: boolean): void {
    this.showConfirmReset = false;
    if (confirm) {
      this.reset.emit();
    }
  }
}
